import { PRODUCTION_PROOF } from '../config/site';

export default function ProductionProofBand() {
  return (
    <section className="production-proof" aria-label="Production proof">
      <div className="container">
        <ul className="production-proof__list">
          {PRODUCTION_PROOF.map((item) => (
            <li key={item.id} className="production-proof__item">
              <span className="production-proof__label">{item.label}</span>
              <p>{item.detail}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
